@let isLoginButton = layout() === layouts.PUBLIC || !userProfile();
@let organizationName = currentOrganization()?.name;
@let isBurgerVersion = host() === 'burger' && layout() === layouts.PRIVATE;
@let pending = isPending();
@let avatar = userAvatar();

<button
  class="user-badge"
  [class.user-badge--no-organization]="!organizationName"
  [attr.data-login]="isLoginButton"
  [attr.data-short]="!organizationName"
  [attr.data-version-full]="isBurgerVersion"
  [disabled]="pending || undefined">
  <div class="user-badge__content">
    @if (isLoginButton) {
      <evc-icon
        class="icon icon--login"
        size="sm"
        icon="profil-fill" />
      <span class="login">{{ i18n.login() }}</span>
    } @else if (pending) {
      <evc-skeleton
        variant="text"
        size="medium"
        class="skeleton-name" />
    } @else if (organizationName || avatar) {
      @if (organizationName) {
        <span class="name">{{ organizationName }}</span>
      }

      @if (pending) {
        <evc-skeleton
          variant="lead-visual"
          size="small"
          shape="round"
          class="skeleton-avatar" />
      } @else if (avatar) {
        <evc-avatar
          [avatar]="avatar"
          class="avatar"
          size="sm" />
      } @else {
        <span class="badge"></span>
      }
    }
  </div>

  @if (!isLoginButton && !pending) {
    <evc-icon
      class="icon icon--dropdown"
      size="sm"
      icon="chevron-up" />
  }
</button>
